<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/fondo5.jpg"
  style="background-image: url('assets/img/fondo5.jpg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white mt-100">
          <h3 style="color: white">
            AMBIENTES URBANOS
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="welcome-section pt-80 pt-pd-60 pt-40" style="background-image: url('/assets/img/fondo-tomo11.png'); background-size: cover;
background-position: center;">
  <div class="container">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-8 m-auto text-center">
        <div class="section-title-wrap">
          <h2>Consulta de Ambientes Urbanos</h2>
          <p class="mb-0" style="font-weight: 300;">A continuación, se muestra la lista de los ambientes urbanos
            catalogados del Centro Histórico de Cusco, los que hacen referencias a plazas, miradores y calles de la
            lista de
            nuestro Centro Histórico.
          </p>
        </div>
      </div><!-- End Section title -->
    </div>
  </div>
</section>


<div class="page-wrapper"
  style="background-image: url('/assets/img/fondo-leyenda-catalogacion.png'); background-size: cover; background-position: center;">
  <div class="accordion-content-wrapper mt-80 mt-md-80 mt-sm-50 mb-80 mb-md-80 mb-sm-50">
    <div class="container">
      <div class="row">

        <div class="col-12">
          <div class="product-description-review">
            <!-- Product Description Tab Menu -->
            <ul class="nav nav-tabs desc-review-tab-menu" id="desc-review-tab" role="tablist">
              <li><a class="" id="desc-tab" data-toggle="tab" href="#descriptionContent" role="tab"
                  aria-selected="false">PLAZAS Y MIRADORES</a></li>
              <li><a id="profile-tab" data-toggle="tab" href="#reviewContent" class="active">CALLES</a></li>
            </ul><!-- Product Description Tab Content -->
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade" id="descriptionContent">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/AMBIENTE URBANO PLAZOLETA BELEN.pdf" target="_blank"> AMBIENTE URBANO PLAZOLETA BELEN</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/AMBIENTE URBANO PLAZOLETA SANTIAGO.pdf" target="_blank">AMBIENTE URBANO PLAZOLETA SANTIAGO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/AMBIENTE URBANO TETEQAQA.pdf" target="_blank">AMBIENTE URBANO TETEQAQA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Informe del Parque Arqueológico del Qorikancha.pdf" target="_blank">Informe del Parque Arqueológico del Qorikancha</a></td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/INFORME HATUN RIMAQPAMPA.pdf" target="_blank">INFORME HATUN RIMAQPAMPA </a></td>
                    </tr>
                    <tr>
                      <th scope="row">6</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/INFORME HUCHUY RIMAQPMPA.pdf" target="_blank">INFORME HUCHUY RIMAQPMPA </a></td>
                    </tr>
                    <tr>
                      <th scope="row">7</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Informe Plaza de Armas.pdf" target="_blank"> Informe Plaza de Armas</a></td>
                    </tr>
                    <tr>
                      <th scope="row">8</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/INFORME PLAZA KUSIPATA.pdf" target="_blank"> INFORME PLAZA KUSIPATA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">9</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/INFORME PLAZA SAN FRANCISCO.pdf" target="_blank"> INFORME PLAZA SAN FRANCISCO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">10</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/INFORME PLAZOLETA SAN BLAS.pdf" target="_blank"> INFORME PLAZOLETA SAN BLAS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">11</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/INFORME PLAZOLETA SANTA TERESA.pdf" target="_blank"> INFORME PLAZOLETA SANTA TERESA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">12</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/INFORME PUMAQCHUPAN.pdf" target="_blank">INFORME PUMAQCHUPAN </a></td>
                    </tr>
                    <tr>
                      <th scope="row">13</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Mirador Qosqo Qawarina .pdf" target="_blank"> Mirador Qosqo Qawarina </a></td>
                    </tr>
                    <tr>
                      <th scope="row">14</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Parque España.pdf" target="_blank"> Parque España</a></td>
                    </tr>
                    <tr>
                      <th scope="row">15</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Plazoleta Almudena.pdf" target="_blank"> Plazoleta Almudena</a></td>
                    </tr>
                    <tr>
                      <th scope="row">16</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Plazoleta de Santa Ana.pdf" target="_blank"> Plazoleta de Santa Ana</a></td>
                    </tr>
                    <tr>
                      <th scope="row">17</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Plazoleta de Santa Catalina.pdf" target="_blank"> Plazoleta de Santa Catalina</a></td>
                    </tr>
                    <tr>
                      <th scope="row">18</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Plazoleta de Santo Domingo.pdf" target="_blank"> Plazoleta de Santo Domingo</a></td>
                    </tr>
                    <tr>
                      <th scope="row">19</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Plazoleta Jesus Lambarri.pdf" target="_blank"> Plazoleta Jesus Lambarri </a></td>
                    </tr>
                    <tr>
                      <th scope="row">20</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Plazoleta Ladislao Espinar.pdf" target="_blank"> Plazoleta Ladislao Espinar</a></td>
                    </tr>
                    <tr>
                      <th scope="row">21</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Plazoleta Nazarenas.pdf" target="_blank"> Plazoleta Nazarenas</a></td>
                    </tr>
                    <tr>
                      <th scope="row">22</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Plazoleta San Pedro.pdf" target="_blank"> Plazoleta San Pedro </a></td>
                    </tr>
                    <tr>
                      <th scope="row">23</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Plazoleta Silvac.pdf" target="_blank"> Plazoleta Silvac</a></td>
                    </tr>
                    <tr>
                      <th scope="row">24</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Plazoleta Tricentenario.pdf" target="_blank"> Plazoleta Tricentenario</a></td>
                    </tr>
                    <tr>
                      <th scope="row">25</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/WAKA MESA REDONDA.pdf" target="_blank"> WAKA MESA REDONDA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">26</th>
                      <td><a href="assets/pdf/ambientes-urbanos/plazas-miradores/Waka Sapantiana.pdf" target="_blank"> Waka Sapantiana</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="tab-pane fade active show" id="reviewContent">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/7 ANGELITOS.pdf" target="_blank"> 7 ANGELITOS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/AV DE LA RAZA.pdf" target="_blank"> AV DE LA RAZA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/AV El Sol.pdf" target="_blank"> AV El Sol</a></td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/AV GARCILASO.pdf" target="_blank"> AV GARCILASO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/AV PARDO.pdf" target="_blank"> AV PARDO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">6</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/AV Regional.pdf" target="_blank"> AV Regional</a></td>
                    </tr>
                    <tr>
                      <th scope="row">7</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/AV Teófilo Guaylupo.pdf" target="_blank"> AV Teófilo Guaylupo</a></td>
                    </tr>
                    <tr>
                      <th scope="row">8</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/AV Tullumayu.pdf" target="_blank"> AV Tullumayu</a></td>
                    </tr>
                    <tr>
                      <th scope="row">9</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/Balcon Cusqueño.pdf" target="_blank"> Balcon Cusqueño</a></td>
                    </tr>
                    <tr>
                      <th scope="row">10</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE  NUEVA BAJA.pdf" target="_blank"> CALLE  NUEVA BAJA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">12</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE  PURGATORIO.pdf" target="_blank"> CALLE  PURGATORIO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">13</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/Calle 7 Ventanas.pdf" target="_blank"> Calle 7 Ventanas</a></td>
                    </tr>
                    <tr>
                      <th scope="row">14</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE ABRACITOS.pdf" target="_blank"> CALLE ABRACITOS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">15</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE AMARGURA.pdf" target="_blank"> CALLE AMARGURA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">16</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE AREQUIPA.pdf" target="_blank"> CALLE AREQUIPA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">17</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE ARRAYAN.pdf" target="_blank"> CALLE ARRAYAN</a></td>
                    </tr>
                    <tr>
                      <th scope="row">18</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE ATAÚD.pdf" target="_blank"> CALLE ATAÚD</a></td>
                    </tr>
                    <tr>
                      <th scope="row">19</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE AWAQPINTA.pdf" target="_blank"> CALLE AWAQPINTA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">20</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE AYACUCHO.pdf" target="_blank"> CALLE AYACUCHO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">21</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE CHAPARRO.pdf" target="_blank"> CALLE CHAPARRO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">23</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/Calle Chiwanpata.pdf" target="_blank"> Calle Chiwanpata</a></td>
                    </tr>
                    <tr>
                      <th scope="row">24</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/Calle Del Medio.pdf" target="_blank"> Calle Del Medio</a></td>
                    </tr>
                    <tr>
                      <th scope="row">25</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE GENERAL BUENDIA.pdf" target="_blank"> CALLE GENERAL BUENDIA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">26</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE HOSPITAL.pdf" target="_blank"> CALLE HOSPITAL</a></td>
                    </tr>
                    <tr>
                      <th scope="row">27</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE LORETO.pdf" target="_blank"> CALLE LORETO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">28</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE MARQUES.pdf" target="_blank"> CALLE MARQUES</a></td>
                    </tr>
                    <tr>
                      <th scope="row">29</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE MELOQ.pdf" target="_blank"> CALLE MELOQ</a></td>
                    </tr>
                    <tr>
                      <th scope="row">30</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE NUEVA.pdf" target="_blank"> CALLE NUEVA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">31</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE PAMPA DE LA ALIANZA.pdf" target="_blank"> CALLE PAMPA DE LA ALIANZA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">32</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE PROCURADORES.pdf" target="_blank"> CALLE PROCURADORES</a></td>
                    </tr>
                    <tr>
                      <th scope="row">33</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE Q'ERA.pdf" target="_blank"> CALLE Q'ERA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">34</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE RECOLETA.pdf" target="_blank"> CALLE RECOLETA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">35</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE SAN ANDRES.pdf" target="_blank"> CALLE SAN ANDRES</a></td>
                    </tr>
                    <tr>
                      <th scope="row">36</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/Calle San Pedro.pdf" target="_blank"> Calle San Pedro</a></td>
                    </tr>
                    <tr>
                      <th scope="row">37</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE SANTA CATALINA ANGOSTA.pdf" target="_blank"> CALLE SANTA CATALINA ANGOSTA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">38</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE SANTA CLARA.pdf" target="_blank"> CALLE SANTA CLARA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">39</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE SAPHY.pdf" target="_blank"> CALLE SAPHY</a></td>
                    </tr>
                    <tr>
                      <th scope="row">40</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE SIETE CULEBRAS.pdf" target="_blank"> CALLE SIETE CULEBRAS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">41</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE SUYT'UQHATU.pdf" target="_blank"> CALLE SUYT'UQHATU</a></td>
                    </tr>
                    <tr>
                      <th scope="row">42</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE TEQSIQOCHA.pdf" target="_blank"> CALLE TEQSIQOCHA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">43</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE TIGRE.pdf" target="_blank"> CALLE TIGRE</a></td>
                    </tr>
                    <tr>
                      <th scope="row">44</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE TRES CRUCES DE ORO.pdf" target="_blank"> CALLE TRES CRUCES DE ORO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">45</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE TRIUNFO.pdf" target="_blank"> CALLE TRIUNFO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">46</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CALLE TUPAC AMARU.pdf" target="_blank"> CALLE TUPAC AMARU</a></td>
                    </tr>
                    <tr>
                      <th scope="row">47</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CHOQUECHACA.pdf" target="_blank"> CHOQUECHACA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">48</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CORDOBA DEL TUCUMÁN.pdf" target="_blank"> CORDOBA DEL TUCUMÁN</a></td>
                    </tr>
                    <tr>
                      <th scope="row">49</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CUESTA DE MIRACALCETAS.pdf" target="_blank"> CUESTA DE MIRACALCETAS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">50</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/CUESTA DEL ALMIRANTE.pdf" target="_blank"> CUESTA DEL ALMIRANTE</a></td>
                    </tr>
                    <tr>
                      <th scope="row">51</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/HISTORIA PASAJE CHASQUI.pdf" target="_blank"> HISTORIA PASAJE CHASQUI</a></td>
                    </tr>
                    <tr>
                      <th scope="row">52</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/HISTORIA PORTAL MANTAS.pdf" target="_blank"> HISTORIA PORTAL MANTAS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">53</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME  CALLE KABRACANCHA .pdf" target="_blank"> INFORME  CALLE KABRACANCHA </a></td>
                    </tr>
                    <tr>
                      <th scope="row">54</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME  CUESTA RESBALOSA.pdf" target="_blank"> INFORME  CUESTA RESBALOSA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">55</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME AV. CENTENARIO 2º.pdf" target="_blank"> INFORME AV. CENTENARIO 2º</a></td>
                    </tr>
                    <tr>
                      <th scope="row">56</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME AV. DON BOSCO.pdf" target="_blank"> INFORME AV. DON BOSCO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">57</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE  ALMAGRO.pdf" target="_blank"> INFORME CALLE  ALMAGRO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">58</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE  CENIZA.pdf" target="_blank"> INFORME CALLE  CENIZA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">59</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE  SANTA TERESA .pdf" target="_blank"> INFORME CALLE  SANTA TERESA </a></td>
                    </tr>
                    <tr>
                      <th scope="row">60</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE AFLIGIDOS.pdf" target="_blank"> INFORME CALLE AFLIGIDOS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">61</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE ARONES.pdf" target="_blank"> INFORME CALLE ARONES</a></td>
                    </tr>
                    <tr>
                      <th scope="row">62</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE ATOQSAYCUCHI.pdf" target="_blank"> INFORME CALLE ATOQSAYCUCHI</a></td>
                    </tr>
                    <tr>
                      <th scope="row">63</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE CONCEVIDAYOC.pdf" target="_blank"> INFORME CALLE CONCEVIDAYOC</a></td>
                    </tr>
                    <tr>
                      <th scope="row">64</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE CRUZ VERDE.pdf" target="_blank"> INFORME CALLE CRUZ VERDE</a></td>
                    </tr>
                    <tr>
                      <th scope="row">65</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE EDUCANDAS.pdf" target="_blank"> INFORME CALLE EDUCANDAS </a></td>
                    </tr>
                    <tr>
                      <th scope="row">66</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE ESPADEROS.pdf" target="_blank"> INFORME CALLE ESPADEROS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">67</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE ESPINAR.pdf" target="_blank"> INFORME CALLE ESPINAR</a></td>
                    </tr>
                    <tr>
                      <th scope="row">68</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE GARCILASO.pdf" target="_blank"> INFORME CALLE GARCILASO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">69</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE GRANADA.pdf" target="_blank"> INFORME CALLE GRANADA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">70</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE HELADEROS.pdf" target="_blank"> INFORME CALLE HELADEROS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">71</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE HERRAJES2.pdf" target="_blank"> INFORME CALLE HERRAJES2</a></td>
                    </tr>
                    <tr>
                      <th scope="row">72</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE INTIKAHUARINA.pdf" target="_blank"> INFORME CALLE INTIKAHUARINA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">73</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE LADRILLOS.pdf" target="_blank"> INFORME CALLE LADRILLOS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">74</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE LECHUGAL.pdf" target="_blank"> INFORME CALLE LECHUGAL</a></td>
                    </tr>
                    <tr>
                      <th scope="row">75</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE MARURI.pdf" target="_blank"> INFORME CALLE MARURI</a></td>
                    </tr>
                    <tr>
                      <th scope="row">76</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE MESON DE LA ESTRELLA.pdf" target="_blank"> INFORME CALLE MESON DE LA ESTRELLA </a></td>
                    </tr>
                    <tr>
                      <th scope="row">77</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE NUEVA ALTA.pdf" target="_blank"> INFORME CALLE NUEVA ALTA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">78</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE PALACIO.pdf" target="_blank"> INFORME CALLE PALACIO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">79</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE PAVITOS.pdf" target="_blank"> INFORME CALLE PAVITOS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">80</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE PERA.pdf" target="_blank"> INFORME CALLE PERA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">81</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE PERA_1.pdf" target="_blank"> INFORME CALLE PERA_1</a></td>
                    </tr>
                    <tr>
                      <th scope="row">82</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE PLATEROS.pdf" target="_blank"> INFORME CALLE PLATEROS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">83</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE PLAZOLETA.pdf" target="_blank"> INFORME CALLE PLAZOLETA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">84</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE QASQAPARO.pdf" target="_blank"> INFORME CALLE QASQAPARO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">85</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE ROBERTO GÖHRING.pdf" target="_blank"> INFORME CALLE ROBERTO GÖHRING</a></td>
                    </tr>
                    <tr>
                      <th scope="row">86</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE ROMERITOS.pdf" target="_blank"> INFORME CALLE ROMERITOS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">87</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE SAN BERNARDO.pdf" target="_blank"> INFORME CALLE SAN BERNARDO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">88</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE SAN JUAN DE DIOS.pdf" target="_blank"> INFORME CALLE SAN JUAN DE DIOS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">89</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE SAN MIGUEL.pdf" target="_blank"> INFORME CALLE SAN MIGUEL</a></td>
                    </tr>
                    <tr>
                      <th scope="row">90</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE SIETE BORREGUITOS.pdf" target="_blank"> INFORME CALLE SIETE BORREGUITOS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">91</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE SIETE CUARTONES.pdf" target="_blank"> INFORME CALLE SIETE CUARTONES</a></td>
                    </tr>
                    <tr>
                      <th scope="row">92</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE TEATRO.pdf" target="_blank"> INFORME CALLE TEATRO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">93</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE TEQTE.pdf" target="_blank"> INFORME CALLE TEQTE</a></td>
                    </tr>
                    <tr>
                      <th scope="row">94</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE TOCUYEROS.pdf" target="_blank"> INFORME CALLE TOCUYEROS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">95</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE TORDO.pdf" target="_blank"> INFORME CALLE TORDO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">96</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE TRINITARIAS.pdf" target="_blank"> INFORME CALLE TRINITARIAS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">97</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE VITOQUE.pdf" target="_blank"> INFORME CALLE VITOQUE</a></td>
                    </tr>
                    <tr>
                      <th scope="row">98</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE Y PORTAL MANTAS.pdf" target="_blank"> INFORME CALLE Y PORTAL MANTAS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">99</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CALLE ZETAS.pdf" target="_blank"> INFORME CALLE ZETAS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">100</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CARMEN ALTO.pdf" target="_blank"> INFORME CARMEN ALTO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">101</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CARMEN BAJO.pdf" target="_blank"> INFORME CARMEN BAJO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">102</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CUESTA DE SANTA ANA.pdf" target="_blank"> INFORME CUESTA DE SANTA ANA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">103</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CUESTA Q'ANCHIPATA.pdf" target="_blank"> INFORME CUESTA Q'ANCHIPATA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">104</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME CUESTA SAN BLAS.pdf" target="_blank"> INFORME CUESTA SAN BLAS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">105</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME HATUNRUMIYOQ.pdf" target="_blank"> INFORME HATUNRUMIYOQ</a></td>
                    </tr>
                    <tr>
                      <th scope="row">106</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME MIRADOR PANTICALLE.pdf" target="_blank"> INFORME MIRADOR PANTICALLE</a></td>
                    </tr>
                    <tr>
                      <th scope="row">107</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME PAMPA DEL CASTILLO.pdf" target="_blank"> INFORME PAMPA DEL CASTILLO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">108</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME PANTIPATA.pdf" target="_blank"> INFORME PANTIPATA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">109</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME PASAJE CHASQUI.pdf" target="_blank"> INFORME PASAJE CHASQUI</a></td>
                    </tr>
                    <tr>
                      <th scope="row">110</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME PROLONGACIÓN TRINITARIAS.pdf" target="_blank"> INFORME PROLONGACIÓN TRINITARIAS</a></td>
                    </tr>
                    <tr>
                      <th scope="row">111</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME PSJ CONCEPCIÓN.pdf" target="_blank"> INFORME PSJ CONCEPCIÓN</a></td>
                    </tr>
                    <tr>
                      <th scope="row">112</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME PSJ GRACE.pdf" target="_blank"> INFORME PSJ GRACE</a></td>
                    </tr>
                    <tr>
                      <th scope="row">113</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME PSJ INCA ROCA.pdf" target="_blank"> INFORME PSJ INCA ROCA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">114</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME PSJ SAN SEBASTIAN.pdf" target="_blank"> INFORME PSJ SAN SEBASTIAN</a></td>
                    </tr>
                    <tr>
                      <th scope="row">115</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME PZLT CONCEPCIÓN.pdf" target="_blank"> INFORME PZLT CONCEPCIÓN</a></td>
                    </tr>
                    <tr>
                      <th scope="row">116</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME SANTA CATALINA ANCHA.pdf" target="_blank"> INFORME SANTA CATALINA ANCHA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">117</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/INFORME TANDAPATA.pdf" target="_blank"> INFORME TANDAPATA</a></td>
                    </tr>
                    <tr>
                      <th scope="row">118</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/PUMACURCO.pdf" target="_blank"> PUMACURCO</a></td>
                    </tr>
                    <tr>
                      <th scope="row">119</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/QORI CALLE.pdf" target="_blank"> QORI CALLE</a></td>
                    </tr>
                    <tr>
                      <th scope="row">120</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/SAN AGUSTIN.pdf" target="_blank"> SAN AGUSTIN</a></td>
                    </tr>
                    <tr>
                      <th scope="row">121</th>
                      <td><a href="assets/pdf/ambientes-urbanos/calles/WAYNAPATA.pdf" target="_blank"> WAYNAPATA</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
